/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { WarehouseMovement } from '../../models/warehouse-movement';
import { WarehouseOpsLoadDtoCreate } from '../../models/warehouse-ops-load-dto-create';

export interface WarehouseControllerLoadFromOrder$Params {
      body: WarehouseOpsLoadDtoCreate
}

export function warehouseControllerLoadFromOrder(http: HttpClient, rootUrl: string, params: WarehouseControllerLoadFromOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WarehouseMovement;
}>> {
  const rb = new RequestBuilder(rootUrl, warehouseControllerLoadFromOrder.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: WarehouseMovement;
      }>;
    })
  );
}

warehouseControllerLoadFromOrder.PATH = '/warehouse/load';
